<template>
  <section class="mb-5">
    <h2 class="display-4">Liste den Abwicklungen</h2>
    <span class="me-2">Neu Abwicklung hinzufügen:</span>
    <button
      type="button"
      class="btn btn-primary"
      title="Neue Abwicklung hinzufügen"
      data-bs-toggle="modal"
      data-bs-target="#modalFormProceed"
    >
      <i class="fa-solid fa-plus"></i>
    </button>
    <!-- Modal -->
    <div
      class="modal fade"
      id="modalFormProceed"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="modalFormProceedLabel"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalFormProceedLabel">Neue Abwicklung hinzufügen</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="title" class="form-label">Titel</label>
              <input
                type="text"
                class="form-control"
                id="title"
                v-model="data.title"
              />
            </div>
            <div class="mb-3">
              <label for="description" class="form-label">Beschreibung</label>
              <textarea
                class="form-control"
                id="description"
                v-model="data.description"
                rows="3"
              ></textarea>
            </div>

            <div class="mb-3">
              <label for="state" class="form-label">Status</label>
              <select
                id="state"
                v-model="data.state"
                class="form-select"
                aria-label="Default select example">
                <option value="0">Nicht verfügbar</option>
                <option value="1">verfügbar</option>
              </select>
            </div>
          </div>
          <div class="modal-footer" data-bs-dismiss="modal">
            <button type="button" class="btn btn-link">Abbrechen</button>
            <button
              type="button"
              class="btn btn-primary"
              @click="addOrEditProceed"
            >
              Speichern
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="list-group my-2" v-if="proceed">
      <div class="list-group-item list-group-item-action" v-for="(item, index) in proceed" :key="index">
        <div class="d-flex w-100 justify-content-between mb-2">
          <h5 class="text-primary mt-2">{{ item.title }}</h5>
          <small class="">
            <div class="input-group">
            <select
                class="form-select"
                v-model="item.state"
                aria-label="Default select example"
              >
                <option value="0">Nicht verfügbar</option>
                <option value="1">verfügbar</option>
            </select>
              <button
                class="btn btn-outline-primary"
                title="Speichern"
                @click="changeProceeState(item)">
                <i class="fa-solid fa-sm fa-floppy-disk"></i>
              </button>
              <button
                type="button"
                title="Bearbeiten"
                @click="data = item"
                class="btn btn-outline-success"
                data-bs-toggle="modal"
                data-bs-target="#modalFormProceed">
                <i class="fa-solid fa-sm fa-pen-to-square"></i>
              </button>
              <button
                class="btn btn-outline-dark"
                title="Löschen"
                @click="deleteProceed(item, index)">
                <i class="fa-solid fa-sm fa-trash"></i>
              </button>
            </div>
          </small>
        </div>
        <p class="mb-1 col-9">{{ item.description }}</p>
      </div>
    </div>
    <table v-else class="table">
      <tbody>
        <tr v-for="(item, index) in 5" :key="index">
          <th scope="row">
            <p class="placeholder-glow">
              <span class="placeholder col-12"></span>
            </p>
          </th>
          <td>
            <p class="placeholder-glow">
              <span class="placeholder col-12"></span>
            </p>
          </td>
          <td>
            <p class="placeholder-glow">
              <span class="placeholder col-12"></span>
            </p>
          </td>
          <td>
            <p class="placeholder-glow">
              <span class="placeholder col-12"></span>
            </p>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
export default {
  name: "Proceed",

  data() {
    return {
      proceed: undefined,
      data: {
        title: "",
        description: "",
        state: 1,
      },
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.loadProceed();
    });
  },

  watch: {},

  methods: {
    loadProceed() {
      this.$store.state.modules.api
        .loadProceed()
        .then((resp) => {
          console.log(resp);
          if (resp.status == 200) {
            this.proceed = resp.data.units;
          }
          this.$store.state.utils.loaded = true;
        })
        .catch((err) => {
          this.$store.state.utils.loaded = true;
        });
    },

    addOrEditProceed() {
      console.log(this.data);
      this.$store.state.modules.api
        .addOrEditProceed(this.data)
        .then((resp) => {
          if (resp.status == 200) {
            if (resp.data.new) {
              this.proceed.push(resp.data.unit);
            }
            this.data = {
              title: "",
              description: "",
              state: 1,
            };

            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                message: "Die Abwicklung wurde erfolgreich hinzugefügt",
              },
              2500
            );
          } else {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                title: "Fehlermeldung",
                message: "Etwas ist schief gelaufen. :(",
              },
              2500
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    changeProceeState(item) {
      this.$store.state.modules.api
        .changeProceeState(item)
        .then((resp) => {
          // console.log(resp);
          if (resp.status == 200) {
            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                title: "Abwicklungstatus",
                message: "Status wurde zu " + item.state + " geändert",
              },
              2500
            );
          }
        })
        .catch((err) => {});
    },

    deleteProceed(item, index) {
      this.$store.state.modules.api
        .deleteProceed(item)
        .then((resp) => {
          // console.log(resp);
          if (resp.status == 200) {
            this.proceed.splice(index, 1);
            this.$store.state.utils.setNewNotifications(
              {
                type: "success",
                title: "Löschen",
                message: "Das Abwicklung wurde erfolgreich entfernt!",
              },
              2500
            );
          }
        })
        .catch((err) => {});
    },
  },
};
</script>
